import {BehaviorSubject} from 'rxjs';
import {filter, map, startWith, shareReplay} from 'rxjs/operators';
import {array2Map} from '@/helper/array';

export const spots$ = new BehaviorSubject([]);

export const spotOptions$ = spots$.pipe(map((items) => items.map((item) => ({value: item.symbol, text: item.displaySymbol}))));

export const stSpotSymbolMaps$ = spots$.pipe(map(convertSTSymbolMaps), shareReplay(1));

// 以symbol作为key给行情使用
export const spotsCache$ = spots$.pipe(
  filter((o) => o.length > 0),
  map((o) => array2Map(o, 'symbol')),
  startWith(new Map()),
  shareReplay(1)
);

// 以baseCurrency作为key给钱包使用
export const spotsCacheWBase$ = spots$.pipe(
  filter((o) => o.length > 0),
  map((o) =>
    o.reduce((p, c) => {
      if (!p.has(c.baseCurrency)) {
        return p.set(c.baseCurrency, [c]);
      }
      const prev = p.get(c.baseCurrency);
      return p.set(c.baseCurrency, [...prev, c]);
    }, new Map())
  ),
  startWith(new Map()),
  shareReplay(1)
);

export const marginCache$ = spots$.pipe(
  filter((o) => o.length > 0),
  map((spots) => spots.filter((spot) => spot.hasOwnProperty('leverage') && spot.leverage > 0)),
  map((o) => array2Map(o, 'symbol')),
  startWith(new Map()),
  shareReplay(1)
);

function convertSTSymbolMaps(spots) {
  return Object.fromEntries(spots.filter((spot) => spot.stStatus === 1).map((spot) => [spot.symbol, spot]));
}
